(function () {
  if (window.__ecRechargeDrawerCheckoutGuard) return;
  window.__ecRechargeDrawerCheckoutGuard = true;

  var canonicalProductViews = {
    'shilajit-pure-organic-himalayan': 'resin-default-v1',
    'shilajit-extract': 'capsules-default-v1',
    'atlas-x-10-in-1-masculinity-maximiser': 'atlas-x-default-v1'
  };

  function canonicalProductUrl(href) {
    if (!href || href.charAt(0) === '#') return href;
    try {
      var productUrl = new URL(href, window.location.origin);
      var match = productUrl.pathname.match(/\/products\/([^/]+)\/?$/);
      if (!match) return href;

      var view = canonicalProductViews[match[1]];
      if (!view) return href;

      productUrl.searchParams.set('view', view);
      return productUrl.pathname + productUrl.search + productUrl.hash;
    } catch (error) {
      return href;
    }
  }

  window.ECCanonicalProductUrl = canonicalProductUrl;

  function normalizeProductLink(anchor) {
    if (!anchor || !anchor.getAttribute) return;

    var href = anchor.getAttribute('href');
    var normalizedHref = canonicalProductUrl(href);
    if (normalizedHref && normalizedHref !== href) {
      anchor.setAttribute('href', normalizedHref);
    }
  }

  function normalizeProductLinks(root) {
    if (!root) return;
    if (root.matches && root.matches('a[href]')) normalizeProductLink(root);
    if (root.querySelectorAll) {
      Array.from(root.querySelectorAll('a[href]')).forEach(normalizeProductLink);
    }
  }

  normalizeProductLinks(document);

  document.addEventListener('click', function (event) {
    var anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    normalizeProductLink(anchor);
  }, true);

  try {
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        Array.from(record.addedNodes || []).forEach(normalizeProductLinks);
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (error) {}

  function routeRechargeDrawerToCheckout(form, button, event) {
    if (!form || !button) return false;

    var actionPath = new URL(form.action || '/cart', window.location.origin).pathname.replace(/\/+$/, '');
    var dialog = form.closest('[role="dialog"]');
    var rechargeRoot = document.getElementById('recharge-storefront-experiences');
    var isCheckoutButton = button.matches('button[data-slot="button"]')
      && button.type === 'submit'
      && /^checkout$/i.test((button.textContent || '').trim());

    if (!actionPath.endsWith('/cart') || !rechargeRoot || !dialog || !isCheckoutButton) return false;
    if (window.__ecRechargeDrawerCheckoutRouting) return true;

    window.__ecRechargeDrawerCheckoutRouting = true;
    event.preventDefault();
    event.stopImmediatePropagation();

    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    window.location.assign(root + 'checkout');
    return true;
  }

  document.addEventListener('click', function (event) {
    var path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
    var button = path.find(function (candidate) {
      return candidate && candidate.matches && candidate.matches('button[data-slot="button"]');
    }) || null;

    if (button && button.form) routeRechargeDrawerToCheckout(button.form, button, event);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    var button = event.submitter || (form && form.querySelectorAll
      ? Array.from(form.querySelectorAll('button[data-slot="button"]')).find(function (candidate) {
          return candidate.type === 'submit' && /^checkout$/i.test((candidate.textContent || '').trim());
        })
      : null);

    routeRechargeDrawerToCheckout(form, button, event);
  }, true);
})();
